/* src/app/componetns/DisabledPage/styles.js */

export default () => ({
  fillPage: {
    position: 'absolute',
    backgroundColor: '#eee',
    display: 'flex',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.7,
    zIndex: 2000,
  },
  text: {
    
  },
});



// WEBPACK FOOTER //
// ./src/app/components/DisabledPage/styles.js